import React, { useState, useRef, useEffect } from 'react';
import { BsThreeDots } from 'react-icons/bs';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { exportOrders } from 'interfaces/order';

function ExportMenu(props: {
    transparent?: boolean;
    vertical?: boolean;
    onClose?: any;
    range?: any;
}) {
    const { transparent, vertical, range } = props;
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);
    const buttonRef = useRef<HTMLButtonElement>(null);
    const [menuPosition, setMenuPosition] = useState({ top: 0, right: 0 });

    const fetchOrdersCSv = async () => {
        try {
            const blob = await exportOrders(range);
            if (!blob) return;
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `export-commandes.csv`;
            link.click();
            setIsOpen(false);
        } catch (error) {
            console.error('Error generating PDF:', error);
        }
    };

    const handleToggle = () => {
        if (!isOpen && buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            setMenuPosition({
                top: rect.bottom + window.scrollY + 4,
                right: window.innerWidth - rect.right + window.scrollX,
            });
        }
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    return (
        <div ref={menuRef} className="relative">
            <button
                ref={buttonRef}
                onClick={handleToggle}
                className={`flex items-center text-xl hover:cursor-pointer ${
                    transparent
                        ? 'bg-none text-white hover:bg-none active:bg-none'
                        : vertical
                          ? 'bg-none text-navy-700 dark:text-white'
                          : 'bg-lightPrimary py-2 px-2 text-toola-500 hover:bg-gray-100'
                } linear justify-center rounded-lg font-bold transition duration-200`}
            >
                {vertical ? (
                    <p className="text-[24px] hover:cursor-pointer text-navy-700">
                        <BsThreeDotsVertical />
                    </p>
                ) : (
                    <BsThreeDots className="h-5 w-5 text-navy-700" />
                )}
            </button>

            {isOpen && (
                <div
                    className="fixed z-[9999] w-max rounded-xl bg-white py-3 px-4 text-sm shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none"
                    style={{ 
                        top: `${menuPosition.top}px`, 
                        right: `${menuPosition.right}px` 
                    }}
                >
                    <p
                        className="hover:text-black flex cursor-pointer items-center gap-2 text-gray-600 hover:font-medium whitespace-nowrap"
                        onClick={fetchOrdersCSv}
                    >
                        Export commandes aux dates sélectionnées
                    </p>
                </div>
            )}
        </div>
    );
}

export default ExportMenu;
